"use client";
import Script from "next/script";
import React, { useState, useEffect, useRef } from "react";

export const OsanoConsentChangeHandler = () => {
  const [initialConsetState, _setInitialConsentState] = useState({});
  const [initialConsentTriggered, _setInitialConsentTriggered] = useState(false);
  const initialConsentTriggeredRef = useRef(initialConsentTriggered);
  const initialConsetStateRef = useRef(initialConsetState);

  const setInitialConsentTriggered = (data) => {
    initialConsentTriggeredRef.current = data;
    _setInitialConsentTriggered(data);
  };
  const setInitialConsentState = (data) => {
    initialConsetStateRef.current = data;
    _setInitialConsentState(data);
  };

  useEffect(() => {
    setInitialConsentState(window?.Osano?.cm?.getConsent());

    const refreshOnConsent = (updatedConsentState) => {
      Object.keys(updatedConsentState).forEach((consentCategory) => {
        if (
          updatedConsentState[consentCategory] === "DENY" &&
          updatedConsentState[consentCategory] !== initialConsetStateRef.current[consentCategory] &&
          initialConsentTriggeredRef.current
        ) {
          const refresh = confirm(
            "We will need to refresh the page to save your preferences. Any other unsaved changes will be lost.",
          );
          if (refresh) {
            location.reload();
          }
        }
      });
      setInitialConsentState(updatedConsentState);
      // Required because Osano fires this listener once on setting initial consent
      if (!initialConsentTriggered) {
        setInitialConsentTriggered(true);
      }
    };
    if (typeof window !== "undefined") {
      window?.Osano?.cm?.addEventListener("osano-cm-consent-saved", refreshOnConsent);
    }

    return () => {
      window?.Osano?.cm?.removeEventListener("osano-cm-consent-saved", refreshOnConsent);
    };
  }, [initialConsentTriggered]);

  return null;
};

export const NextOsanoScripts = ({ id, isProduction }) => {
  return (
    <>
      {isProduction && id && (
        <Script strategy="beforeInteractive" src={`https://cmp.osano.com/${id}/osano.js`} />
      )}
    </>
  );
};

export const OsanoScripts = ({ id, isProduction }) => {
  return <>{isProduction && id && <script async src={`https://cmp.osano.com/${id}/osano.js`} />}</>;
};
